import { render, staticRenderFns } from "./edit-user-details-dialog.vue?vue&type=template&id=780753bd"
import script from "./edit-user-details-dialog.vue?vue&type=script&lang=js"
export * from "./edit-user-details-dialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/nortonpigozzo/Development/nisoftwares/VeinsEnergia-api/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('780753bd')) {
      api.createRecord('780753bd', component.options)
    } else {
      api.reload('780753bd', component.options)
    }
    module.hot.accept("./edit-user-details-dialog.vue?vue&type=template&id=780753bd", function () {
      api.rerender('780753bd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "assets/modules/user/components/edit-user-details-dialog.vue"
export default component.exports